import { Reducer } from 'redux';
import { UserProfile } from "../../Models/Profile/UserProfile";
import { ProfileActions } from './Actions';
import { IProfileStore } from "./IProfileStore";
import * as Constants from './Constants'

const initialWifiStore: IProfileStore =
{
    profile: UserProfile.emptyProfile()
};

export const ProfileReducer: Reducer<IProfileStore, ProfileActions> = (
    state = initialWifiStore,
    action,) => {
    switch (action.type) {
        case Constants.SET_PROFILE: {
            return {
                ...state, profile: { ...action.profile }
            };
        }
        default: return state;
    }
}
